import addLog from "./addLog";
import isDevMode from "./environment.function";

const getBuyerAPIDomain = (isToUseAuthZero = false): URL => {
  if (isDevMode()) {
    return new URL("api", "https://cms.uat.britishcarauctions.net");
  }

  if (typeof process.env.VIRTUAL_DOMAIN === "string") {
    if (isToUseAuthZero) {
      return new URL("api", process.env.VIRTUAL_DOMAIN);
    }

    const buyerAPIDomainUrl = new URL(
      `${process.env.URL_SUFFIX}/api`,
      `${process.env.VIRTUAL_DOMAIN}`
    );

    return buyerAPIDomainUrl;
  }

  addLog({
    message: "Could not return a valid BuyerAPI Domain.",
  });

  return null;
};

export default getBuyerAPIDomain;
